import request from '@/utils/request'

export function fetchCategoryList (query) {
  return request({
    url: '/card/api/card_product_category/index',
    method: 'get',
    params: query
  })
}

export function createCategory (data) {
  return request({
    url: '/card/api/card_product_category/insert',
    method: 'post',
    data
  })
}

export function updateCategory (data) {
  return request({
    url: '/card/api/card_product_category/update',
    method: 'post',
    data
  })
}

export function deleteCategory (id) {
  return request({
    url: '/card/api/card_product_category/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/product-category.js